var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button-fill"},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))]),_c('div',{staticClass:"bg"})])}
var staticRenderFns = []

export { render, staticRenderFns }